<template>
  <div class="container">
    <router-view />
    <CartDrawer />
  </div>
</template>

<script setup>
import { onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import CartDrawer from '@/components/CartDrawer.vue'
import { useSessionStore } from '@/stores/session'
import { useTableStore } from '@/stores/table'

const sessionStore = useSessionStore()
const tableStore = useTableStore()
const router = useRouter()
const route = useRoute()

onMounted(() => {
  if (sessionStore.restoreSession()) {
    console.log('[App] Session restored:', sessionStore.sessionId, 'slug:', sessionStore.restaurantSlug)
    tableStore.bindSession(sessionStore.sessionId)
    
    // If we are on root landing page but have a session, go to restaurant menu
    if (route.path === '/' && sessionStore.restaurantSlug) {
      router.push(`/${sessionStore.restaurantSlug}/menu`)
    }
  } else {
    console.log('[App] No session to restore')
  }
})
</script>

<style>
/* Global styles are in assets/main.css */
</style>
